import type { Sale } from "@/types/sales/api-types/sale-types";
import type { SaleCheckoutFormValues } from "@/zod-schemas/sales/sale-checkout-schema";
import type { WalkInSaleFormValues } from "@/zod-schemas/sales/walk-in-sale-schema";

export const EMPTY_SALE_SERVICE_LINE: SaleCheckoutFormValues["services"][number] =
  {
    service_id: 0,
    staff_id: 0,
    start_time: "",
    duration_minutes: 0,
    price: 0,
  };

export const EMPTY_SALE_PRODUCT_LINE: SaleCheckoutFormValues["products"][number] =
  {
    product_id: 0,
    staff_id: 0,
    price: 0,
  };

/** Unset method is `""` until the user picks one. */
export const EMPTY_SALE_PAYMENT_LINE: SaleCheckoutFormValues["payments"][number] =
  {
    method: "" as SaleCheckoutFormValues["payments"][number]["method"],
    amount: 0,
  };

export const getSaleCheckoutFormValues = (
  sale: Sale
): SaleCheckoutFormValues => ({
  discount_percent: Number(sale.discount_percent),
  services:
    sale.services.length === 0
      ? [{ ...EMPTY_SALE_SERVICE_LINE }]
      : sale.services.map((line) => ({
          service_id: line.service_id,
          staff_id: line.staff_id,
          start_time: line.start_time,
          duration_minutes: line.duration_minutes,
          price: Number(line.price),
        })),
  products: sale.products.map((line) => ({
    product_id: line.product_id,
    staff_id: line.staff_id,
    price: Number(line.price),
  })),
  payments:
    sale.payments.length === 0
      ? [{ ...EMPTY_SALE_PAYMENT_LINE }]
      : sale.payments.map((line) => ({
          method: line.method,
          amount: Number(line.amount),
        })),
});

export const getWalkInSaleFormValues = (): WalkInSaleFormValues => ({
  discount_percent: 0,
  services: [],
  products: [],
  payments: [{ ...EMPTY_SALE_PAYMENT_LINE }],
});
